import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PersonalInformationSection from '../shared/personalInformationSection/PersonalInformationSection'
import EmailSection from '../shared/emailSection/EmailSection'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import PhoneSection from '../shared/phoneNumberSection/PhoneNumberSection'
import NormalizeInput from '../shared/phoneNumberSection/PhoneNumberUtility'
import PasswordSection from '../shared/passwordSection/PasswordSection'
import { UserProfileDataViewModel } from '../../models/UserDataViewModel'
import { Button } from 'carbon-components-react'
import ConfirmPasswordModal from './ConfirmPasswordModal'
import IconCheckMarkHeader from '../../globals/images/icon-checkmark-header.svg'
import { LiveAnnouncer, LiveMessage } from 'react-aria-live'
import { trackEventMessage, trackEventMessageFailure } from '../../TelemetryService'
import { EventModel } from './../../models/EventModel'
import { FF_MFA_SHOW_MESSAGE_ENABLED, MFA_ENROLL_STATUS, PERSONALIZED_COOKIE_NAME, PROFILE_EDITED } from '../../constants'
import BuildDynamicMsg from '../shared/adaHelpers/BuildDynamicMsg'
import { emailSemiMsgMarkup } from '../shared/constants/Validations'
import { AdditionalSecurity } from '../AdditionalSecurity/AdditionalSecurity.jsx'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { MfaWizard } from '../mfaWizard/MfaWizard'
import { MFADomain } from '../domain/mfa.services'
import { MFA, MFASteps } from '../mfaWizard/MFASteps'
import { MFAService } from '../api/MFAFlowAPI'
import { refreshLDContextAndGetFFValue } from '../shared/launchDarklyHelper/launchDarkly'
import { getCookieValueByKey } from '../../utils/cookieUtils'
import { removeAskMeLaterLocalStorageItem } from '../../utils/localStorageUtils.js'

export default withLDConsumer()( class EditProfile extends Component { 
    constructor() { 
        super()
        this.state = { 
            email: '',
            confirmEmail: '',
            validEmail: true,
            isEmailValidationLoading: false,
            mobilePhoneNumber: '',
            validPhoneNumber: true,
            isPhoneNumberValidationLoading: false,
            firstName: '',
            lastName: '',
            validPI: true,
            loading: false,
            password: '',
            passwordConfirmation: '',
            passwordIsValid: true,
            open: false,
            isMfaEnabled: false,
            showMFA: false,
            mfaStep: MFASteps.ChooseFactor,
            mfaWizzardPhoneNumber: '',
            factors: [],
            fromEditProfileAfterEdition: false,
            FFcontextUpdated: false
     }

        this.handleSubmit = this.handleSubmit.bind( this )
        this.customerAlertsUrl = this.customerAlertsUrl.bind( this )
        this.setPasswordValue = this.setPasswordValue.bind( this )
        this.setPasswordConfirmationValue = this.setPasswordConfirmationValue.bind( this )
        this.setPasswordIsValid = this.setPasswordIsValid.bind( this )
        this.clearState = this.clearState.bind( this )
        this.setEmailIsValid = this.setEmailIsValid.bind( this )
        this.setEmailValues = this.setEmailValues.bind( this )
        this.setIsEmailValidationLoading = this.setIsEmailValidationLoading.bind( this )
        this.setPersonalInformationIsValid = this.setPersonalInformationIsValid.bind( this )
        this.setPersonalInformationValues = this.setPersonalInformationValues.bind( this )
        this.setPhoneNumberIsValid = this.setPhoneNumberIsValid.bind( this )
        this.setPhoneNumberValue = this.setPhoneNumberValue.bind( this )
        this.setIsPhoneValidationLoading = this.setIsPhoneValidationLoading.bind( this )
        this.setShowMFA = this.setShowMFA.bind( this )
        this.setMFAStep = this.setMFAStep.bind( this )
        this.setFactors = this.setFactors.bind( this )
        this.setFromEditProfileAfterEdition = this.setFromEditProfileAfterEdition.bind( this )
        this.getMfaUserId = this.getMfaUserId.bind( this )
        this.setMfaWizzardPhoneNumber = this.setMfaWizzardPhoneNumber.bind( this )
        this.handleModalOpenClose = this.handleModalOpenClose.bind( this )
        this.setFFcontextUpdated = this.setFFcontextUpdated.bind( this )
 }

    get forgotPasswordUrl() { 
        return this.props.config.forgotPasswordUrl || process.env.REACT_APP_FORGOT_PASSWORD
 }
    get contactUsUrl() { 
        return this.props.config.contactUsUrl || process.env.REACT_APP_REDIRECT_TO_ABOUT_URL
 }
    get logInApiUrl() { 
        return this.props.config.logInApiUrl || process.env.REACT_APP_LOG_IN_API_URL
 }

    get logOffUrl() { 
        return this.props.config.logOffUrl || process.env.REACT_APP_LOGOFF_URL
 }

    get ffMfaEnabled() { 
        if ( !this.props.ldClient ) return false

        return this.props.ldClient.allFlags()[ FF_MFA_SHOW_MESSAGE_ENABLED ]
 }

    getFFMfaUpdatedValue = async () => { 
        if ( !this.props.ldClient ) return false

        const oktaUserNameValue = `${ this.props.config.userProfileDataViewModel.webId }@eversource.com`
        if ( !this.state.FFcontextUpdated ) { 
            this.setFFcontextUpdated( true )

            const stateCode = getCookieValueByKey( PERSONALIZED_COOKIE_NAME, 'StateCode' )

            const ffValue = await refreshLDContextAndGetFFValue( this.props.config.userProfileDataViewModel.email, oktaUserNameValue, stateCode, this.props.ldClient, FF_MFA_SHOW_MESSAGE_ENABLED )
            return ffValue
     }
        else
            return this.props.ldClient.allFlags()[ FF_MFA_SHOW_MESSAGE_ENABLED ]
 }

    getMfaUserId = () => { 
        return MFADomain.getOktaEncryptedUserId()
 }

    componentDidMount() { 
        this.setState( { 
            ...this.props.config?.userProfileDataViewModel,
            confirmEmail: '',
            password: '',
            passwordConfirmation: '',
            mobilePhoneNumber: NormalizeInput( this.props.config?.userProfileDataViewModel?.mobilePhoneNumber )
     } )

        this.getFFMfaUpdatedValue()

        document.getElementById( 'title' )?.click()
 }

    customerAlertsUrl = () => { 
        return process.env.REACT_APP_CUSTOMER_ALERTS
 }

    setFromEditProfileAfterEdition = ( fromEditProfileAfterEdition ) => { 
        this.setState( { fromEditProfileAfterEdition: fromEditProfileAfterEdition } )
 }

    setSetpAndFactorsForMFA = ( step, factors ) => { 
        this.setState( { mfaStep: step, factors: factors, showMFA: true } )
 }

    showMFAOnStep = ( step ) => { 
        this.setState( { mfaStep: step, showMFA: true } )
 }

    setFFcontextUpdated = ( value ) => { 
        this.setState( { FFcontextUpdated: value } )
 }

    showMFAActivationStepToConfirmCode = ( step, fromEditProfileAfterEdition ) => { 
        this.setState( { mfaStep: step, showMFA: true, fromEditProfileAfterEdition: fromEditProfileAfterEdition } )
 }

    getEnrolledFactors = async () => { 
        const userIdValue = MFADomain.getOktaEncryptedUserId()

        const userFactors = await MFAService.GetUserFactors( userIdValue )

        this.setFactors( userFactors )
 }

    handleSubmit = ( enableSubmit ) => { 
        if ( enableSubmit ) { 

            this.setState( { loading: true } )
            const { config, showErrorMessage, showHideSuccessMessage } = this.props
            const { webId } = config.userProfileDataViewModel
            const { email, password, firstName, lastName, mobilePhoneNumber, isDGContractor, hiddenValue, confirmEmail, passwordConfirmation } = this.state

            this.setPersonalInformationValues( firstName, lastName )
            this.setEmailValues( email )
            this.setPhoneNumberValue( mobilePhoneNumber )

            this.props.handleSubmit( email, confirmEmail, webId, mobilePhoneNumber, password, passwordConfirmation, isDGContractor, hiddenValue, firstName, lastName )
                .then( data => { 
                    if ( data.IsSuccess ) { 
                        trackEventMessage( new EventModel( PROFILE_EDITED.SUCCESS, webId ) )
                        this.clearState( mobilePhoneNumber, firstName, lastName, email, hiddenValue )
                        this.setState( { open: false, loading: false } )  // , submitted: false 
                        showHideSuccessMessage( true )
                 } else { 
                        trackEventMessageFailure( new EventModel( PROFILE_EDITED.FAILURE, webId ) )
                        showErrorMessage()
                 }
                    window.scrollTo( 0, 0 )

                    if ( confirmEmail && confirmEmail.length > 0 ) { // login email was updated
                        const emailFactorIsActive = this.state.factors.some( f => f.status == MFA_ENROLL_STATUS.ACTIVE && f.factorType == MFA.factorType.email )

                        if ( emailFactorIsActive ) { 
                            this.showMFAActivationStepToConfirmCode( MFASteps.ActivateFactor, true )
                     } else { 
                            this.getEnrolledFactors()
                     }
                 }
             } )
                .catch( data => { 
                    this.setState( { loading: false } )
                    trackEventMessageFailure( new EventModel( PROFILE_EDITED.FAILURE, webId ), data )
                    showErrorMessage()
             } )
     }
 }

    clearState = ( cMobilePhoneNumber, cFirstName, cLastName, cEmail, cHiddenValue ) => { 
        this.props.config.userProfileDataViewModel.mobilePhoneNumber = String( cMobilePhoneNumber ).replace( /[^0-9]/g, '' )
        this.props.config.userProfileDataViewModel.firstName = cFirstName
        this.props.config.userProfileDataViewModel.lastName = cLastName
        this.props.config.userProfileDataViewModel.email = cEmail
        this.props.config.userProfileDataViewModel.hiddenValue = cHiddenValue

        this.setState( { 
            password: '',
            passwordConfirmation: '',
            confirmEmail: '',
            showReEnterEmail: false,
            fromEditProfileAfterEdition: false
     } )
 }

    setPasswordValue = ( password ) => { 
        this.setState( { password: password } )
 }

    setPasswordConfirmationValue = ( passwordConfirmation ) => { 
        this.setState( { passwordConfirmation: passwordConfirmation } )
 }

    setPasswordIsValid = ( isValid ) => { 
        this.setState( { passwordIsValid: isValid } )
 }

    setEmailIsValid = ( validEmail ) => { 
        this.setState( { validEmail: validEmail } )
 }

    setEmailValues = ( email, emailConfirmation ) => { 
        this.setState( { confirmEmail: emailConfirmation, email: email } )
 }

    setIsEmailValidationLoading = ( loading ) => { 
        this.setState( { isEmailValidationLoading: loading } )
 }

    setPersonalInformationIsValid = ( validPI ) => { 
        this.setState( { validPI: validPI } )
 }

    setPersonalInformationValues = ( firstName, lastName ) => { 
        this.setState( { firstName: firstName, lastName: lastName } )
 }

    setPhoneNumberValue = ( mobilePhoneNumber ) => { 
        this.setState( { mobilePhoneNumber: mobilePhoneNumber } )
 }

    setPhoneNumberIsValid = ( validPhoneNumber ) => { 
        this.setState( { validPhoneNumber: validPhoneNumber } )
 }

    setIsPhoneValidationLoading = ( loading ) => { 
        this.setState( { isPhoneNumberValidationLoading: loading } )
 }

    setShowMFA = ( show ) => { 
        if ( show ) window.scrollTo( 0, 0 )
        this.setState( { showMFA: show } )
 }

    setFactors = ( factors ) => { 
        this.setState( { factors: factors } )
 }

    setMfaWizzardPhoneNumber = ( phoneNumber ) => { 
        this.setState( { mfaWizzardPhoneNumber: phoneNumber } )
 }

    setUserId = ( userId ) => { 
        this.setState( { userId: userId } )
 }

    setMFAStep = ( mfaStep ) => { 
        this.setState( { mfaStep: mfaStep } )
 }

    handleModalOpenClose = ( value, redirect ) => { 
        if ( redirect ) { 
            location.assign( UrlBuilder( { url: this.logOffUrl, buildURL: true } ) )
     }
        this.setState( { open: value } )
 }
    showHideSuccessMessage = ( e ) => { 
        this.props.showHideSuccessMessage( false )
 }

    validateChangeInFields = ( originalObject ) => { 
        const original = { 
            'email': originalObject.email ? originalObject.email : '',
            'password': '',
            'confirmPassword': originalObject.confirmPassword ? originalObject.confirmPassword : '',
            'firstName': originalObject.firstName ? originalObject.firstName : '',
            'lastName': originalObject.lastName ? originalObject.lastName : '',
            'mobilePhoneNumber': originalObject.mobilePhoneNumber ? originalObject.mobilePhoneNumber : '',
     }
        const form = { 
            'email': this.state.email ? this.state.email : '',
            'password': this.state.password ? this.state.password : '',
            'confirmPassword': this.state.confirmPassword ? this.state.confirmPassword : '',
            'firstName': this.state.firstName ? this.state.firstName : '',
            'lastName': this.state.lastName ? this.state.lastName : '',
            'mobilePhoneNumber': this.state.mobilePhoneNumber ? this.state.mobilePhoneNumber.replace( /-/g, '' ) : ''
     }
        return JSON.stringify( original ) !== JSON.stringify( form )
 }

    render() { 

        const { 
            email, validEmail, isEmailValidationLoading, validPI,
            isPhoneNumberValidationLoading, passwordIsValid, validPhoneNumber,
            password, passwordConfirmation
     } = this.state
        const enableSubmit = !( ( !validEmail || isEmailValidationLoading ||
            !validPI || !validPhoneNumber || isPhoneNumberValidationLoading || !passwordIsValid )
        ) && ( this.validateChangeInFields( this.props.config?.userProfileDataViewModel ) )

        const phoneNumberConfig = { 
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const personalInformationConfig = { 
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const emailConfig = { 
            inputWrapperClassName: 'c-form-email-section',
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const confirmEmailConfig = { 
            inputWrapperClassName: 'c-form-email-section',
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const customerAlertsUrl = UrlBuilder( { url: this.customerAlertsUrl(), buildURL: true } )

        const passwordConfig = { 
            className: 'c-form-input',
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const passwordConfirmationConfig = { 
            className: 'c-form-input',
            onFocus: ( e ) => this.showHideSuccessMessage()
     }

        const onFactorAddClick = ( factors, selectedFactor, update ) => { 
            let step = null
            if ( update ) { 
                if ( selectedFactor == MFA.FACTORS.SMS ) step = MFASteps.SmsUpdate
         } else { 
                if ( selectedFactor == MFA.FACTORS.EMAIL ) step = MFASteps.EmailEnrollment
                if ( selectedFactor == MFA.FACTORS.SMS ) step = MFASteps.SmsEnrollment
         }

            this.setSetpAndFactorsForMFA( step, factors )
     }

        const onSetupClick = ( factors ) => { 
            this.setSetpAndFactorsForMFA( MFASteps.ChooseFactor, factors )
     }

        const triggerLoginEmailFocus = () => { 
            window.scrollTo( 0, 0 )
            document.getElementById( 'Email' )?.focus()
     }

        const dynamicADAMsg = BuildDynamicMsg( validEmail, validPI, validPhoneNumber, passwordIsValid, true )

        const updateFactors = ( factors ) => { 
            this.setFactors( factors )
     }

        const renderEditProfile = () => { 

            return <>	<main className="c-main sign-in">
                <div className="os-container--max-width">
                    { 
                        this.props.displayMessage ?
                            <div>
                                <h1 className="c-confirmation-edit-profile pb-0 pl-9" tabIndex={ 0 }>
                                    <img src={ IconCheckMarkHeader } alt="Confirmation" className="c-svg-header-icon c-svg-confirmation-edit-profile" />
                                    { 'Profile Successfully Updated' }
                                </h1>
                                <LiveAnnouncer>
                                    <LiveMessage message={ 'Profile Successfully Updated' } aria-live="polite" />
                                </LiveAnnouncer>
                            </div>
                            : null
                 }
                    <div className="c-form-card" style={ { maxWidth: '100em' } }>
                        <div className="c-form-card__container">
                            <h1 id='title' aria-label='Profile page' className="o-heading-alpha" tabIndex="0" style={ { marginBottom: '16px', paddingBottom: '0px' } }>Profile</h1>
                        </div>
                        <div className="c-form-container-section">
                            <EmailSection
                                emailConfig={ emailConfig }
                                confirmEmailConfig={ confirmEmailConfig }
                                dispalyToltip={ false }
                                setEmailIsValid={ this.setEmailIsValid }
                                setEmailValues={ this.setEmailValues }
                                setIsEmailValidationLoading={ this.setIsEmailValidationLoading }
                                showNotification={ true }
                                showHideConfirmEmail={ true }
                                currentEmailValue={ this.props.config.userProfileDataViewModel?.email }
                                notification={ 
                                    { 
                                        contentWrapper: 'c-form-notification-box',
                                        visible: true,
                                        style: 'high-alert',
                                        markup: `${ emailSemiMsgMarkup }<br><a href="${ customerAlertsUrl }"><u><strong>Go to alerts to modify.</strong></u></a>`
                                 }
                             }
                            />

                            <PersonalInformationSection
                                personalInformationConfig={ personalInformationConfig }
                                setPersonalInformationIsValid={ this.setPersonalInformationIsValid }
                                setPersonalInformationValues={ this.setPersonalInformationValues }
                                tittle="Name"
                                currentFirstName={ this.props.config.userProfileDataViewModel?.firstName }
                                currentLastName={ this.props.config.userProfileDataViewModel?.lastName }
                            />
                            <PhoneSection
                                phoneNumberConfig={ phoneNumberConfig }
                                disabled={ this.props.config.disablePhoneNumber }
                                setPhoneNumberValue={ this.setPhoneNumberValue }
                                setPhoneNumberIsValid={ this.setPhoneNumberIsValid }
                                setIsPhoneValidationLoading={ this.setIsPhoneValidationLoading }
                                currentPhoneNumber={ this.props.config.userProfileDataViewModel?.mobilePhoneNumber }
                                webId={ this.props.config.userProfileDataViewModel?.webId }
                            />
                            <PasswordSection
                                passwordConfig={ passwordConfig }
                                passwordConfirmationConfig={ passwordConfirmationConfig }
                                setPasswordIsValid={ this.setPasswordIsValid }
                                setPasswordValue={ this.setPasswordValue }
                                setPasswordConfirmationValue={ this.setPasswordConfirmationValue }
                                passwordValue={ password }
                                passwordConfirmationValue={ passwordConfirmation }
                                email={ email }
                                currentEmail={ this.props.config.userProfileDataViewModel?.email }
                                webId={ this.props.config.userProfileDataViewModel?.webId }
                                displayTitle={ true }
                                displayBox={ true }
                                showInputComponentsInColum={ true }
                                displayNotificacionBottom={ true }
                                formInputsClass='c-form-container-in-column'
                                pswAriaLabel="Edit Password. Optional field. "
                                pswConfariaLabel="Re-Enter Password field. "
                                notification={ 
                                    { 
                                        contentWrapper: 'c-form-notification-box',
                                        visible: true
                                 }
                             }
                            />
                            { this.ffMfaEnabled &&
                                <AdditionalSecurity
                                    webId={ this.props.config.userProfileDataViewModel?.webId }
                                    config={ this.props.config }
                                    onFactorAdd={ ( factors, selectedFactor, update ) => onFactorAddClick( factors, selectedFactor, update ) }
                                    onSetUp={ ( factors ) => onSetupClick( factors ) }
                                    loginEmailFocusClick={ () => triggerLoginEmailFocus() }
                                    updateFactors={ ( factors ) => updateFactors( factors ) }
                                ></AdditionalSecurity>
                         }
                            <Button
                                className={ ` ${ enableSubmit ? 'c-btn c-btn--primary' : 'c-btn c-btn--disabled' } mb-5 c-btn--center-aligned` }
                                onClick={ () => { if ( enableSubmit ) this.setState( { open: true } ) } }
                                tabIndex={ 0 }
                                aria-label={ `Update Profile ${ enableSubmit ? 'Enabled' : 'Disabled. ' + dynamicADAMsg } ` }
                                data-testid="btn-Submit"
                                id="btn-edit-profile"
                            >
                                Update
                            </Button>
                            <ConfirmPasswordModal
                                open={ this.state.open }
                                forgotPasswordUrl={ this.forgotPasswordUrl }
                                contactUsUrl={ this.contactUsUrl }
                                loading={ this.state.loading }
                                onSubmit={ () => this.handleSubmit( enableSubmit ) }
                                changeLoading={ ( value ) => this.setState( { loading: value } ) }
                                webId={ this.props.config.userProfileDataViewModel?.webId }
                                logInApiUrl={ this.logInApiUrl }
                                handleModalOpenClose={ this.handleModalOpenClose }
                                showErrorMessage={ this.props.showErrorMessage }
                                logOffUrl={ this.logOffUrl }
                            />
                        </div>
                    </div>
                </div>
            </main>
            </>
     }

    return ( 
        <> { this.state.showMFA ? <MfaWizard
        returnUrl={ this.state.loginResponseReturnUrl }
        mfaAskMeAgainTimeOut={ this.mfaAskMeAgainTimeOut }
        userId={ this.getMfaUserId() }
        user={ { 
            webId: this.props.config.userProfileDataViewModel?.webId,
            password: password,
            rememberMe: true,
            email: this.props.config?.userProfileDataViewModel.email
        } }
        mfaStep={ this.state.mfaStep }
        phoneNumber={ this.state.mfaWizzardPhoneNumber }
        factors={ this.state.factors }
        errorLoginRequest={ undefined }
        onErrorRetry={ undefined }
        updateFactor={ ( factor ) => this.setState( { factors: MFADomain.setActiveFactor( factor, this.state.factors ) } ) }
        setPhoneNumber={ ( value ) => this.setMfaWizzardPhoneNumber( value ) }
        fromEditProfile={ true }
        fromEditProfileAfterEdition={ this.state.fromEditProfileAfterEdition }
        closeMFAEmbeddedWizzard={ () => this.setState( { showMFA: false, fromEditProfileAfterEdition: false } ) }
        updateFactorsList={ ( factorsList ) => this.setFactors( factorsList ) }
    /> : renderEditProfile() } </> )
 }
    static propTypes = { 
        showErrorMessage: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        displayMessage: PropTypes.bool.isRequired,
        showHideSuccessMessage: PropTypes.func.isRequired,
        config: PropTypes.shape( { 
            webId: PropTypes.string,
            userProfileDataViewModel: PropTypes.instanceOf( UserProfileDataViewModel ),
            forgotPasswordUrl: PropTypes.string,
            logInApiUrl: PropTypes.string,
            disablePhoneNumber: PropTypes.bool,
            logOffUrl: PropTypes.string,
            contactUsUrl: PropTypes.string,
            antiForgeryHeaderName: PropTypes.string,
            oktaClientId: PropTypes.string,
            webId: PropTypes.string
     } ),
        ldClient: PropTypes.instanceOf( Object )
 }
 }
 )